import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import dataSourceReadAction from './dataSourceRead.action.json'

const dataSourceReadDefinition = defineReadAutoAction(
  dataSourceReadAction,
  'dataSource',
)

export default dataSourceReadDefinition
